import { useEffect, useRef, useState } from "react";
import Chevron from "../../../../assets/images/icons/ui/chevron-down-blue.svg?react";
import ArrowIcon from "../../../../assets/images/icons/ui/left-arrow-blue.svg?react";
import EditIcon from "../../../../assets/images/icons/ui/edit.svg?react";
import PersonIcon from "../../../../assets/images/icons/ui/physical-person-blue.svg?react";
import { PersonalInformation } from "../../../../types/interactiveBrokers";
import { texts } from "../../i18n";
import styles from "./Header.module.scss";

const {
  container,
  title,
  back,
  personIcon,
  chevron,
  name,
  dropdown,
  item,
  trigger,
  menu,
  open,
} = styles;

const Dropdown = ({
  personalInformation,
  language,
  onEditClicked: handleEditClicked,
}: {
  onEditClicked: () => void;
  personalInformation: PersonalInformation;
  language: "en" | "es";
}) => {
  const [isDropdownMenuVisible, setIsDropdownMenuVisible] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleDropdownTriggerCliked = () =>
    setIsDropdownMenuVisible((prev) => !prev);

  const handleClickedOutside = (event: Event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as HTMLElement)
    )
      setIsDropdownMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickedOutside, true);
    return () => {
      document.removeEventListener("click", handleClickedOutside, true);
    };
  }, [dropdownRef]);

  return (
    <div
      ref={dropdownRef}
      className={`${dropdown} ${isDropdownMenuVisible ? open : ""}`}
    >
      <div className={trigger} onClick={handleDropdownTriggerCliked}>
        <div className={name}>
          <PersonIcon className={personIcon} />
          {personalInformation.firstName} {personalInformation.lastName}
        </div>
        <Chevron className={`${chevron}  transition-transform`} />
      </div>

      <div
        className={`flex flex-col gap-3 ${menu} ${
          isDropdownMenuVisible ? "opacity-100" : "opacity-0 invisible"
        } absolute z-10 transition-opacity`}
      >
        <div className="flex gap-2 justify-between">
          <span>{texts[language].personalInformation.title}</span>
          <EditIcon className="cursor-pointer" onClick={handleEditClicked} />
        </div>

        <div className={item}>
          <label>{texts[language].personalInformation.name}</label>
          <span>
            {personalInformation.firstName} {personalInformation.lastName}
          </span>
        </div>
        <div className={item}>
          <label>{texts[language].personalInformation.email}</label>
          <span>{personalInformation.email}</span>
        </div>
        <div className={item}>
          <label>{texts[language].personalInformation.country}</label>
          <span>{personalInformation.countryOfBirth}</span>
        </div>
        {personalInformation?.referral && (
          <div className={item}>
            <label>{texts[language].personalInformation.referral}</label>
            <span>{personalInformation.referral.name}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const Header = (props: {
  personalInformation: PersonalInformation | null;
  onBackClicked: () => void;
  onEditClicked: () => void;
  language: "en" | "es";
}) => {
  const {
    personalInformation,
    onBackClicked: handleBackClicked,
    onEditClicked: handleEditClicked,
    language,
  } = props;

  return (
    <div className={` ${container}`}>
      <div
        className={`flex gap-2 cursor-pointer items-center ${back}`}
        onClick={handleBackClicked}
      >
        <ArrowIcon />
        <span>{texts[language].backButton}</span>
      </div>

      <span className={title}>{texts[language].title}</span>

      {personalInformation && (
        <Dropdown
          {...props}
          personalInformation={personalInformation}
          onEditClicked={handleEditClicked}
        />
      )}
    </div>
  );
};

export default Header;
